// Phone input mask: (XXX) XXX-XXXX
function applyPhoneMask(input) {
    input.addEventListener("input", () => {
        const digits = input.value.replace(/\D/g, "").slice(0, 10);
        let formatted = "";
        if (digits.length > 0) formatted = "(" + digits.slice(0, 3);
        if (digits.length >= 3) formatted += ") " + digits.slice(3, 6);
        if (digits.length >= 6) formatted += "-" + digits.slice(6, 10);
        input.value = formatted;
    });
}

function validateEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}

function validatePhone(value) {
    return value.replace(/\D/g, "").length === 10;
}

function showError(input, message) {
    input.classList.add("invalid");
    let errorEl = input.parentElement.querySelector(".field-error");
    if (!errorEl) {
        errorEl = document.createElement("div");
        errorEl.className = "field-error";
        input.parentElement.appendChild(errorEl);
    }
    errorEl.textContent = message;
}

function clearError(input) {
    input.classList.remove("invalid");
    const errorEl = input.parentElement.querySelector(".field-error");
    if (errorEl) errorEl.textContent = "";
}

const MIN_SUBMIT_TIME_MS = 2000;

function initContactForm() {
    const form = document.getElementById("contact-form");
    if (!form) return;

    const formLoadedAt = Date.now();

    const phoneInput = form.querySelector("#phone");
    if (phoneInput) applyPhoneMask(phoneInput);

    // Clear errors on input
    form.querySelectorAll("input, textarea").forEach((el) => {
        el.addEventListener("input", () => clearError(el));
    });

    form.addEventListener("submit", (e) => {
        e.preventDefault();
        let valid = true;

        const firstName = form.querySelector("#first_name");
        const lastName = form.querySelector("#last_name");
        const email = form.querySelector("#email");
        const phone = form.querySelector("#phone");
        const message = form.querySelector("#message");
        const status = document.getElementById("contact-form-status")

            // Reset
        ;[
            firstName,
            lastName,
            email,
            phone,
            message
        ].forEach(clearError);
        status.hidden = true;

        if (!firstName.value.trim()) {
            showError(firstName, "First name is required");
            valid = false;
        }
        if (!lastName.value.trim()) {
            showError(lastName, "Last name is required");
            valid = false;
        }
        if (!email.value.trim()) {
            showError(email, "Email is required");
            valid = false;
        }
        else if (!validateEmail(email.value.trim())) {
            showError(email, "Please enter a valid email address");
            valid = false;
        }
        if (!phone.value.trim()) {
            showError(phone, "Phone number is required");
            valid = false;
        }
        else if (!validatePhone(phone.value)) {
            showError(phone, "Please enter a complete 10-digit phone number");
            valid = false;
        }
        if (!message.value.trim()) {
            showError(message, "Message is required");
            valid = false;
        }

        if (!valid) return;

        // Anti-bot: reject if honeypot field is filled
        const honeypot = form.querySelector("#website");
        if (honeypot && honeypot.value) {
            status.hidden = false;
            status.className = "form-status success";
            status.textContent = "Thank you! Your message has been received. We'll be in touch soon.";
            form.reset();
            return;
        }

        // Anti-bot: reject if submitted too quickly
        if (Date.now() - formLoadedAt < MIN_SUBMIT_TIME_MS) {
            status.hidden = false;
            status.className = "form-status success";
            status.textContent = "Thank you! Your message has been received. We'll be in touch soon.";
            form.reset();
            return;
        }

        const submitBtn = form.querySelector(".contact-submit");
        submitBtn.disabled = true;
        submitBtn.textContent = "Sending...";

        fetch("https://webhooks.prod.acts.media/webhooks/ideed/contact_form", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                first_name: firstName.value.trim(),
                last_name: lastName.value.trim(),
                email: email.value.trim(),
                phone: phone.value.trim(),
                message: message.value.trim(),
            }),
        })
            .then((res) => {
                if (!res.ok) throw new Error("Request failed");
                status.hidden = false;
                status.className = "form-status success";
                status.textContent = "Thank you! Your message has been received. We'll be in touch soon.";
                form.reset();
            })
            .catch(() => {
                status.hidden = false;
                status.className = "form-status error";
                status.textContent = "Something went wrong. Please try again or email us at info@ideed.me.";
            })
            .finally(() => {
                submitBtn.disabled = false;
                submitBtn.textContent = "Send Message";
            });
    });
}

document.addEventListener("DOMContentLoaded", initContactForm);
